import React, { memo } from 'react'
import { IoMdCalendar } from 'react-icons/io'
import { MdBlock, MdOutlineLaptop, MdSave } from 'react-icons/md'

interface BlockedChatIconProps {
  icon: string
}

function renderIcon(icon: string) {
  switch (icon) {
    case 'block':
      return <MdBlock />
    case 'calendar':
      return <IoMdCalendar />
    case 'laptop':
      return <MdOutlineLaptop />
    case 'save':
      return <MdSave />
  }
}

const BlockedChatIcon = memo(({ icon }: BlockedChatIconProps) => {
  return <div className='flex items-center'>{renderIcon(icon)}</div>
})

export default BlockedChatIcon
